import { http } from "@/utils/request";
import type { AuthTokens, TokenResponse, UserInfo } from "@/types/auth.types";

const convertTokenResponse = (response: TokenResponse): AuthTokens => ({
  accessToken: response.access_token,
  refreshToken: response.refresh_token,
});

export const authService = {
  // 登录
  login: async (username: string, password: string): Promise<AuthTokens> => {
    const response = await http.post<TokenResponse>(
      "/login",
      { username, password },
      { auth: false }
    );
    return convertTokenResponse(response);
  },

  // 退出
  logout: () => http.get("/logout"),

  // 获取用户信息
  getCurrentUser: async (): Promise<UserInfo> => {
    return http.get<UserInfo>("/me");
  },

  // 创建管理员
  createAdmin: async (
    username: string,
    password: string,
    real_name: string
  ): Promise<AuthTokens> => {
    const response = await http.post<TokenResponse>(
      "/create",
      { username, password, real_name },
      { auth: false }
    );
    return convertTokenResponse(response);
  },

  // 更新用户信息
  updateUserInfo: async (data: {
    real_name?: string;
    email?: string;
    avatar?: string;
  }) => {
    return http.put<UserInfo>("/me", data);
  },

  // 修改密码
  changePassword: async (data: {
    old_password: string;
    new_password: string;
  }) => {
    return http.post("/password", data);
  },
};
